import { Box } from '../../render/parts'
import { WallClock } from '../parts/props'
import type { AssetContext, AssetDefinition } from '../types'

const RADIUS = 0.14
/** `WallClock`'s body is a 35 mm disc centred on z = 0; push it onto the wall. */
const BODY_HALF = 0.0175
/** Dial face sits at z = 0.021 locally — ticks start 1 mm inside it. */
const TICK_Z = 0.0215

/**
 * WALL ITEM — origin on the wall plane, back face at z = 0, growing into +Z.
 *
 * Just the shared `WallClock` plus quarter-hour ticks: at isometric scale a
 * full twelve-mark dial collapses into noise, four marks still read as a clock.
 */
function ClockWall({ accent }: AssetContext) {
  const ring = RADIUS - 0.035
  return (
    <group position={[0, 0, BODY_HALF]}>
      <WallClock r={RADIUS} accent={accent} />
      {[-1, 1].map((side) => (
        <Box key={`v${side}`} tone="darkSoft" size={[0.007, 0.022, 0.003]} position={[0, side * ring, TICK_Z]} />
      ))}
      {[-1, 1].map((side) => (
        <Box key={`h${side}`} tone="darkSoft" size={[0.022, 0.007, 0.003]} position={[side * ring, 0, TICK_Z]} />
      ))}
    </group>
  )
}

export const definition: AssetDefinition = {
  id: 'clock-wall',
  name: 'Reloj de pared',
  category: 'decor',
  footprint: [0.3, 0.04],
  height: 0.3,
  anchor: 'wall',
  mountHeight: 2.05,
  accentable: true,
  keywords: ['reloj', 'hora', 'pared', 'clock', 'wall clock', 'time'],
  Component: ClockWall,
}
